
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { MembersPhysiotherapyModel } from '../../models/consult/members-physiotherapy.model';
import { MembersPhysiotherapyEntity } from '../../../data/repositories/consult/entities/members-physiotherapy.entity';
      
    export class GetMembersPhysiotherapyUseCase implements UseCase<{idZonaAfectacionMuscular:string}, MembersPhysiotherapyModel> {
        constructor(private consult: ConsultRepository) { }
        execute(
            params: { idZonaAfectacionMuscular: string },
        ): Observable<MembersPhysiotherapyEntity> {
    return this.consult.getMembersPhysiotherapy(params);
    }
}